import WsProvider from './provider/WSProvider'

var serviceName = "webservis";
var moduleName = "urun";

var cokluUrunService = {
    imagePath: WsProvider.imagePath,
    imagePathBuyuk: WsProvider.imagePathBuyuk,
    imagePathOrta: WsProvider.imagePathOrta,
    imagePathKucuk: WsProvider.imagePathKucuk,
    belgePath: WsProvider.documentPath,
    path: WsProvider.path,

    urunTopluSecimDetay(urunID){
        var userDataDosPharmacy = localStorage.getItem("userDataDosPharmacy")
        var param = {
            token: userDataDosPharmacy,
            urunID,
            serviceName: moduleName,
            methodName: "urunTopluSecimDetay"
        }
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
        return result
    },

    cokluTekUrunGuncelle(cokluUrunID, adet, birim, fiyat, cokluFiyat, sure, baslangicTarihi, bitisTarihi, durum){
        var userDataDosPharmacy = localStorage.getItem("userDataDosPharmacy")
        var param = {
            token: userDataDosPharmacy,
            cokluUrunID, adet, birim, fiyat, cokluFiyat, sure, baslangicTarihi, bitisTarihi, durum,
            serviceName: moduleName,
            methodName: "cokluTekUrunGuncelle"
        }
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
        return result
    },

    cokluUrunEkle(urunID, cokluUrunler) {
        var userDataDosPharmacy = localStorage.getItem("userDataDosPharmacy")
        var param = {
            token: userDataDosPharmacy,
            urunID, cokluUrunler,
            serviceName: moduleName,
            methodName: "cokluUrunEkle"
        }
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
        return result
    },


    cokluUrunGuncelle(urunID, cokluUrunler) {
        var userDataDosPharmacy = localStorage.getItem("userDataDosPharmacy")
        var param = {
            token: userDataDosPharmacy,
            urunID, cokluUrunler,
            serviceName: moduleName,
            methodName: "cokluUrunEkle"
        }
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
        return result
    },
    
    cokluUrunListele(durum, baslangic, limit) {
        var userDataDosPharmacy = localStorage.getItem("userDataDosPharmacy")
        var param = {
            token: userDataDosPharmacy,
            durum, baslangic, limit,
            serviceName: moduleName,
            methodName: "cokluUrunListele"
        }
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
        return result
    },
    cokluUrunSil(cokluUrunID) {
        var userDataDosPharmacy = localStorage.getItem("userDataDosPharmacy")
        var param = {
            token: userDataDosPharmacy,
            cokluUrunID,
            serviceName: moduleName,
            methodName: "cokluUrunSil"
        }
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
        return result
    },
    cokluUrunDurumGuncelle(durum, cokluUrunID) {
        var userDataDosPharmacy = localStorage.getItem("userDataDosPharmacy")
        var param = {
            token: userDataDosPharmacy,
            durum, cokluUrunID,
            serviceName: moduleName,
            methodName: "cokluUrunDurumGuncelle"
        }
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
        return result
    },

    cokluUrunDetay(cokluUrunID) {
        var userDataDosPharmacy = localStorage.getItem("userDataDosPharmacy")
        var param = {
            token: userDataDosPharmacy,
            cokluUrunID,
            serviceName: moduleName,
            methodName: "cokluUrunDetay"
        }
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
        return result
    },
}

export default cokluUrunService